import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { JOURNAL_PAGE } from '@/constants/testIds';
import { useTilt } from '@/lib/useTilt';

export const JournalCard = ({ post, className = '' }) => {
  const tilt = useTilt(4);
  return (
    <Link
      ref={tilt.ref}
      onMouseMove={tilt.onMouseMove}
      onMouseLeave={tilt.onMouseLeave}
      style={{ ...tilt.style, transition: 'transform 220ms ease-out' }}
      to={`/journal/${post.slug}`}
      className={`group block rounded-2xl border border-[hsl(var(--lxra-border))] bg-[#0F0F10] overflow-hidden will-change-transform ${className}`}
      data-testid={JOURNAL_PAGE.card(post.slug)}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={post.cover_image_url}
          alt={post.title}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover hover-zoom-img"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
      </div>
      <div className="p-5">
        {post.tags?.length > 0 && (
          <p className="text-[11px] tracking-[0.18em] uppercase text-[hsl(var(--lxra-gold))] mb-2">
            {post.tags.join(' · ')}
          </p>
        )}
        <h3 className="font-display text-xl tracking-[0.03em] text-[hsl(var(--lxra-fg))] leading-snug transition-colors duration-300 group-hover:text-[hsl(var(--lxra-gold))]">
          {post.title}
        </h3>
        <p className="mt-2 text-sm text-[hsl(var(--lxra-muted))] leading-relaxed line-clamp-2">{post.excerpt}</p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.1em] text-[hsl(var(--lxra-fg))] group-hover:text-[hsl(var(--lxra-gold))] transition-colors">
          Read More
          <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </Link>
  );
};
